import { useEffect, useState, useRef } from "react";

import { fetchData } from "../utils";
import { faClock, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const ContactBar = () => {
    const barRef = useRef(null);
    const [content, setContent] = useState({})
    const [loader, setLoader] = useState(true)
    
    useEffect (() => {
        fetchData('pageContent/kontakt', 'GET', null, (data) => {
            setContent(data)
            setLoader(false)
        })
    }, [])

    useEffect(() => {
    const updateHeight = () => {
        if (!barRef.current) return;

        if (window.innerWidth <= 1024) {
            const height = barRef.current.offsetHeight - 1; // 👈 минус 1px

            document.documentElement.style.setProperty(
            "--contact-bar-height",
            `${height}px`
            );
        } else {
            document.documentElement.style.setProperty(
            "--contact-bar-height",
            "0px"
            );
        }
    };

    updateHeight();

    const resizeObserver = new ResizeObserver(updateHeight);

    if (barRef.current) {
      resizeObserver.observe(barRef.current);
    }

    window.addEventListener("resize", updateHeight);

    return () => {
        resizeObserver.disconnect();
        window.removeEventListener("resize", updateHeight);
    };
  }, []);

    return (
        <div ref={barRef} className="contact-bar">
            <div className="contact-item">
                <FontAwesomeIcon style={{height: 15}} icon={faEnvelope} />
                <a href={`mailto:${content.email}`}>
                    {content.email}
                </a>
            </div>

            <div className="contact-item">
                <FontAwesomeIcon style={{height: 15}} icon={faPhone} />
                <a href={`tel:${content.telefon}`}>
                    {content.telefon}
                </a>
            </div>

            <div className="contact-item">
                <FontAwesomeIcon style={{height: 15}} icon={faClock} />
                <a>
                    {content.working_time}
                </a>
            </div>
        </div>
    );
};

export default ContactBar;
